import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();
  
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-b from-gray-900 to-black text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <div className="mb-6 sm:mb-8">
              <img 
                src="https://static.readdy.ai/image/b9dffa7b6b8fd92109fabc077dd82307/98eb314ca98fe48673f68b7098bb86f0.png" 
                alt="Mola Közde Kahveci" 
                className="h-16 sm:h-20 w-auto object-contain"
              />
            </div>
            <p className="text-gray-400 leading-relaxed mb-6">
              {t('footer.description')}
            </p>
            <div className="flex space-x-3">
              <a href="https://www.instagram.com/__kahve_molasi__/" target="_blank" rel="nofollow noopener noreferrer" className="w-10 h-10 bg-white/10 hover:bg-amber-600 rounded-full flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-instagram-fill text-lg"></i>
              </a>
              <a href="https://wa.me/905322937352" target="_blank" rel="nofollow noopener noreferrer" className="w-10 h-10 bg-white/10 hover:bg-amber-600 rounded-full flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-whatsapp-fill text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6 text-amber-400">{t('footer.quickLinks')}</h4>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('about')} className="text-gray-400 hover:text-amber-400 transition-colors cursor-pointer">
                  {t('footer.about')}
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('menu')} className="text-gray-400 hover:text-amber-400 transition-colors cursor-pointer">
                  {t('footer.menu')}
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('gallery')} className="text-gray-400 hover:text-amber-400 transition-colors cursor-pointer">
                  {t('footer.gallery')}
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('location')} className="text-gray-400 hover:text-amber-400 transition-colors cursor-pointer">
                  {t('footer.location')}
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="text-gray-400 hover:text-amber-400 transition-colors cursor-pointer">
                  {t('footer.contact')}
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6 text-amber-400">{t('footer.contactInfo')}</h4>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <i className="ri-map-pin-fill text-amber-400 mt-1"></i>
                <span className="text-gray-400 text-sm">
                  {t('location.address')}
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <i className="ri-phone-fill text-amber-400"></i>
                <a href="tel:+905322937352" className="text-gray-400 hover:text-amber-400 transition-colors text-sm cursor-pointer">
                  0532 293 73 52
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <i className="ri-mail-fill text-amber-400"></i>
                <a href="mailto:info@molakozde.com" className="text-gray-400 hover:text-amber-400 transition-colors text-sm cursor-pointer">
                  info@molakozde.com
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6 text-amber-400">{t('footer.workingHours')}</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex justify-between">
                <span className="text-gray-400">{t('footer.everyday')}</span>
                <span className="text-amber-400 font-semibold">{t('footer.open247')}</span>
              </li>
            </ul>
            <div className="mt-6 p-4 bg-amber-600/10 border border-amber-600/20 rounded-xl">
              <p className="text-amber-400 text-sm font-semibold mb-2">{t('footer.reservation')}</p>
              <p className="text-gray-400 text-xs">{t('footer.reservationNote')}</p>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-center items-center">
            <p className="text-gray-400 text-sm text-center">
              {t('footer.copyright')}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
